
<div class="">
 <div class="tabs tabBlue">
      <span class="tablinks" style="font-weight: bold;" onclick="opentab(event, 'page')" id="defaultOpen">Elements</span>  
    </div>
  </div>
  <div class="pageContainer tabcontent pageList elementList" id="page" style="display:block;">
  
    
      <app-all-element-listing></app-all-element-listing>
  </div>